"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageRegions = exports.isValidLanguageTag = void 0;
var intl_getcanonicallocales_1 = require("@formatjs/intl-getcanonicallocales");
var languageInfo_1 = require("./generated/languageInfo");
var isValidLanguageTag = function (tag) {
    return intl_getcanonicallocales_1.isStructurallyValidLanguageTag(tag);
};
exports.isValidLanguageTag = isValidLanguageTag;
var getLanguageRegions = function (language) { var _a; return ((_a = languageInfo_1.languageInfo[language]) === null || _a === void 0 ? void 0 : _a.regions) || []; };
exports.getLanguageRegions = getLanguageRegions;
//# sourceMappingURL=languages.js.map